import { CheckIn } from "@/features/check-in/check-in";
import { CHECK_IN_QUERY } from "@/features/check-in/graphql/check-in-query";

export const Route = createFileRoute({
  component: CheckIn,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient
        .query(CHECK_IN_QUERY, {
          id: params.id,
        })
        .toPromise();
    }
  },
});
